import { Routes } from '@angular/router';
import { AuthGuard } from './features/auth/services/auth.guard';

export const APP_ROUTES: Routes = [
    {
        path: 'auth',
        loadChildren: () => import('./features/auth/auth.routes').then((r) => r.AUTH_ROUTES),
    },
    {
        path: 'error',
        loadComponent: () => import('./core/components/error.component'),
    },
    {
        path: '',
        canActivate: [AuthGuard],
        loadComponent: () => import('./layout/onboarding-layout.component'),
        loadChildren: () => import('./features/dashboard/dashboard.routes').then((r) => r.ONBOARDING_ROUTES),
    },
    {
        path: '**',
        redirectTo: 'error',
    },
];
